import { InputFormCallout, InputFormCalloutProps, TextInput } from "o4a-react";
import * as React from "react";
import { Text } from "@fluentui/react";
import * as Messages from "../../codegen/Messages";

export const enum Fields {
  Name="name",
}
export interface ResourceGroupNewPanelProps extends
  Pick<InputFormCalloutProps, "targetId" | "onClose" | "onSubmit">
{
  description: string;
  defaultValue: string | undefined;
}

export const ResourceGroupNewPanel = ({
  defaultValue,
  description,
  onClose,
  onSubmit,
  targetId,
}: ResourceGroupNewPanelProps): JSX.Element => (
  <InputFormCallout
    title=""
    targetId={targetId}
    onClose={onClose}
    onSubmit={onSubmit}
  >
    <Text
      block
      styles={{
        root: {
          marginBottom: 18,
          fontStyle: "normal",
        },
      }}
      variant="medium"
    >
      {description}
    </Text>
    <TextInput
      required
      defaultValue={defaultValue}
      label={Messages.common.name()}
      fieldName={Fields.Name}
    />
  </InputFormCallout>
);
